var map = {
	"./bash": 1684,
	"./java": 1685,
	"./json": 1686,
	"./julia": 1687,
	"./python": 1688,
	"./r": 1689,
	"./rust": 1690,
	"./scala": 1691,
	"./shell": 1692,
	"./sql": 1693,
	"./xml": 1694,
	"./yaml": 1695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1683;